import React, { Suspense, lazy } from 'react';
import { useTranslation } from 'react-i18next';
import { Container, Row, Col } from 'react-bootstrap';
import { FaTruck, FaLeaf, FaShieldAlt, FaHandshake } from 'react-icons/fa';
import VisionMission from '../components/visionmission';
import 'bootstrap/dist/css/bootstrap.min.css';
import Styles from '../pages/styles.module.css';

const OurTeam = lazy(() => import('../components/OurTeam'));

function About() {
  const { t } = useTranslation();

  const values = [
    {
      icon: <FaLeaf />,
      title: t('Pure & Natural'),
      description: t('No preservatives, no artificial additives. Just pure, wholesome dairy goodness.')
    },
    {
      icon: <FaTruck />,
      title: t('Fresh Delivery'),
      description: t('Farm fresh products delivered daily to your doorstep with care.')
    },
    {
      icon: <FaShieldAlt />,
      title: t('Quality Assured'),
      description: t('Strict quality control and hygiene standards at every step.')
    },
    {
      icon: <FaHandshake />,
      title: t('Trusted Partner'),
      description: t('Loved by families across the region since 2018.')
    }
  ];
  
  return (
    <div className={Styles.appContainer}>
      <section className={Styles.pageSection}>
        <h1 className={Styles.pageHeader}>{t('About Krushiratna Milk')}</h1>
        <p className={Styles.pageIntro}>
          {t('We are committed to delivering the freshest dairy products from our farm into your home. Our team blends traditional care with modern hygiene to ensure every drop is wholesome.')}
        </p>
      </section>

      <section className={Styles.pageSection}>
        <VisionMission />
      </section>

      <section className={Styles.pageSection}>
        <h2 className={Styles.sectionHeading}>{t('Why Choose Us')}</h2>
        <Row className={Styles.valuesGrid}>
          {values.map((value, idx) => (
            <Col md={6} lg={3} key={idx} className="mb-4">
              <div className={Styles.valueCard}>
                <div className={Styles.valueIcon}>{value.icon}</div>
                <h4 className={Styles.valueTitle}>{value.title}</h4>
                <p className={Styles.valueDesc}>{value.description}</p>
              </div>
            </Col>
          ))}
        </Row>
      </section>

      <Suspense fallback={<div>Loading...</div>}>
        <section className={Styles.pageSection}>
          <div className={Styles.sectionCard}>
            <Container>
              <h2 className={Styles.sectionHeading}>{t('Meet Our Team')}</h2>
              <OurTeam />
            </Container>
          </div>
        </section>
      </Suspense>
    </div>
  );
}

export default About;
